<template>
  <div class="gallery-project-link">
    <span class="gallery-project-label">Part of the project</span>
    <router-link to="/aipersonalarchive" custom v-slot="{href,navigate}"><a :href="href" @click="openProject($event,navigate)"><span>AI × Self</span><span class="gallery-project-arrow" aria-hidden="true"><ArrowUpRightIcon data-exhibition-icon /></span></a></router-link>
  </div>
</template>

<script>
export default {
  emits:['project'],
  methods:{openProject(event,navigate){this.$emit('project',event);if(!event.defaultPrevented)navigate(event);}},
};
</script>

<style scoped>
.gallery-project-link{display:flex;align-items:center;gap:10px;color:var(--ex-ink,var(--site-text-primary,#34372f));font-family:'Quattrocento Sans',sans-serif}
.gallery-project-label{font:11px/1.35 'Quattrocento Sans',sans-serif;color:var(--ex-muted,var(--site-text-secondary,#73766b))}
.gallery-project-link a{display:inline-flex;align-items:flex-start;gap:5px;min-height:28px;align-content:center;padding-block:4px;box-sizing:border-box;color:inherit;text-decoration:none;white-space:nowrap;font:400 17px/1.2 'EB Garamond',serif;transform-origin:left center;transition:transform 180ms cubic-bezier(.23,1,.32,1);cursor:var(--site-interactive-cursor,pointer)}
.gallery-project-arrow{display:inline-flex;flex:none;margin-top:1px;transition:transform 180ms cubic-bezier(.23,1,.32,1)}
.gallery-project-arrow :deep(.site-arrow-up-right){width:11px;height:11px;stroke-width:1.45}
.gallery-project-link a:focus-visible{outline:1px solid currentColor;outline-offset:4px}
@media(hover:hover) and (pointer:fine){.gallery-project-link a:hover{transform:scale(1.035)}.gallery-project-link a:hover .gallery-project-arrow{transform:translate(1.5px,-1.5px)}}
@media(prefers-reduced-motion:reduce){.gallery-project-link a,.gallery-project-arrow{transition:none;transform:none!important}}
</style>
